import { NavigationState } from '../common/navigator';
import { HelpedPage } from './tickets/helped-page/helped-page.comp';
import { ContactPage } from './tickets/contact-page/contact-page.comp';
import { TicketsContainer } from './tickets/tickets-container.comp';
import { Icon, iconsMap } from '../common/icons/icon.comp';
// import {NavigationState} from '../common/navigator';
import { Loader } from '../common/loader.comp';
// import {WidgetNavigator} from '../common/navigator';
import { KBContainer } from './kb/kb-container.comp';
import { BaseWidgetProps } from './widget-container';
import { logger } from '../common/utils';
import { ArticlePage } from './kb/article-page/article-page.comp';
import { CategoryPage } from './kb/category-page/category-page.comp';
import { HomePageComp } from './kb/home-page/home-page.comp';
import { SearchResults } from './kb/search-results/search-results.comp';

import { Article, WidgetModuleType, ContactMode, ChatBlockContactMode } from '@wix/answers-api';

import { EventType } from '../common/logger/event-type';
import * as React from 'react';
import { ChatRoomLoader } from './chat/chat-room/chat-room-loader';
import { isChatOpen } from '../common/is-chat-open';

export type DefaultModuleRedirectProps = {
	baseWidgetProps: BaseWidgetProps
};

export class DefaultModuleRedirectComp extends React.Component<DefaultModuleRedirectProps, any> {
	componentDidMount () {
		const { modulesConfig } = this.props.baseWidgetProps.widgetConfig;
		const defaultModule = modulesConfig.defaultModule;
		const isChatDefault = defaultModule === WidgetModuleType.TICKET && modulesConfig.chatEnabled;
		const defaultModuleWithChat = isChatDefault ? WidgetModuleType.CHAT : defaultModule;
		this.props.baseWidgetProps.widgetNavigator.setDefaultModule(defaultModuleWithChat);
	}

	render () {
		return (<Loader color={this.props.baseWidgetProps.widgetConfig.appearance.brandColor} />);
	}
}

export const createWidgetContainerNavigationComps = (baseWidgetProps: BaseWidgetProps, homepageArticles: Article[]) => {
	let currentArticle: Article | null = null;

	const backBtnComp = () => {
		const isKbModuleHasBack = baseWidgetProps.widgetNavigator.isKbModuleHasBack();
		return (isKbModuleHasBack) ?
			(
				<a className='back' onClick={baseWidgetProps.widgetNavigator.goBack}>
					<Icon icon={iconsMap.back} />
				</a>
			)
			: null;
	};

	const ticketsBtnComp = () => {
		const { modulesConfig, chatModuleSettings, tenant } = baseWidgetProps.widgetConfig;
		const { chatEnabled, ticketsEnabled } = modulesConfig;
		const { outsideBusinessHoursSettings, businessHours } = chatModuleSettings;
		const handleClick = () => {
			baseWidgetProps.widgetNavigator.switchModules(
				chatEnabled ? WidgetModuleType.CHAT : WidgetModuleType.TICKET);
			baseWidgetProps.logger.logEvent(EventType.TOGGLE_MODULE, { nextModule: 'contact' });
		};
		const outsideChatHours = ticketsEnabled && chatEnabled && !isChatOpen(businessHours, tenant.timeZone);
		const hideContactOutsideHours = chatEnabled && outsideBusinessHoursSettings.contactMode === ContactMode.BLOCK_CHAT
			&& outsideBusinessHoursSettings.blockContact.chatBlockContactMode === ChatBlockContactMode.HIDE_CONTACT;
		const hideContact = chatEnabled && outsideChatHours && hideContactOutsideHours;

		return (ticketsEnabled && !hideContact) ?
			(
				<a className='go-to-contact' onClick={handleClick}>
					<Icon icon={iconsMap.contact} />
				</a>
			)
			: null;
	};

	const kbBtnComp = () => {
		const hasTicketing = baseWidgetProps.widgetConfig.modulesConfig.knowledgebaseEnabled;
		const handleClick = () => {
			baseWidgetProps.widgetNavigator.switchModules(WidgetModuleType.KB);
			baseWidgetProps.logger.logEvent(EventType.TOGGLE_MODULE, { nextModule: 'kb' });
		};
		return (hasTicketing) ?
			(
				<a className='go-to-kb' onClick={handleClick}>
					<Icon icon={iconsMap.kb} />
				</a>
			)
			: null;
	};

	const handleSearchOnlyMode = () => {
		let isSearchOnly = false;
		const homepageComponents = baseWidgetProps.widgetConfig.kbModuleSettings.homepageComponents;
		const firstSettingsComponent = homepageComponents[0];
		const secondSettingsComponent = homepageComponents[1];
		if (firstSettingsComponent.enabled === false && secondSettingsComponent.enabled === false) {
			const currModule = baseWidgetProps.widgetNavigator.getCurrModules();
			if (currModule === WidgetModuleType.KB && baseWidgetProps.widgetNavigator.isKbHomepage()) {
				parent.postMessage({ kbHomepageSearchOnlyMode: true }, '*');
				isSearchOnly = true;
			} else {
				parent.postMessage({ kbHomepageSearchOnlyMode: false }, '*');
			}
		}
		return isSearchOnly;
	};

	return {
		DefaultModuleRedirectContainerComp: () => (
			<DefaultModuleRedirectComp baseWidgetProps={baseWidgetProps} />
		),

		ModuleContainer: (props: any) => {
			const transition = baseWidgetProps.widgetConfig.appearance.transition;
			const transitionName = baseWidgetProps.widgetNavigator.getModuleTransitionName(transition);
			const currModule = baseWidgetProps.widgetNavigator.getCurrModules();
			const isSearchOnly = baseWidgetProps.widgetConfig.modulesConfig.knowledgebaseEnabled && handleSearchOnlyMode();
			return (
				<div className={`module-container ${transitionName} module-${currModule}${isSearchOnly ? ' search-only' : ''}`}>
					<div className='module'>
						{React.cloneElement(props.children, { key: currModule })}
					</div>
				</div>
			);
		},

		KbContainer: (props: any) => {
			const searchTerm = props.params.term || '';
			return (
				<KBContainer
					baseWidgetProps={baseWidgetProps}
					searchTerm={searchTerm}
					article={currentArticle}
				>
					{backBtnComp()}
					{React.cloneElement(props.children, { key: props.location.pathname })}
				</KBContainer>
			);
		},
		KbHomepage: () => (
			<HomePageComp
				baseConfig={baseWidgetProps}
				articles={homepageArticles}
			>
				{ticketsBtnComp()}
			</HomePageComp>
		),
		SearchResults: (routeProps: { params: { term: string } }) => {
			return <SearchResults term={routeProps.params.term || ''} baseConfig={baseWidgetProps} />;
		},
		ArticlePage: () => (
			<ArticlePage baseConfig={baseWidgetProps} article={currentArticle} />
		),
		CategoryPage: (routeProps: { params: { categoryId: string } }) => (
			<CategoryPage categoryId={routeProps.params.categoryId} baseConfig={baseWidgetProps} />
		),
		onArticlePageEnter: (nextState: any, _: any, callback: any) => {
			baseWidgetProps.widgetNavigator.maybeAddInitialStateToKbHistory(NavigationState.article, nextState.params.articleId);
			baseWidgetProps.kbApi.getArticleNewApi(nextState.params.articleId)
				.then((article: Article) => {
					currentArticle = article;
				}).then(callback)
				.catch((e) => {
					baseWidgetProps.logger.logEvent(EventType.ARTICLE_NOT_FOUND);
					logger(`article id('${nextState.params.articleId}') not found`, e);
				});
		},
		onArticleUriPageEnter: (nextState: any, _: any, callback: any) => {
			baseWidgetProps.widgetNavigator.maybeAddInitialStateToKbHistory(
				NavigationState.articleUri, nextState.params.articleUri);
			baseWidgetProps.kbApi.getArticleByUriNewApi(nextState.params.articleUri)
				.then((article: Article) => {
					currentArticle = article;
				}).then(callback)
				.catch((e) => {
					baseWidgetProps.logger.logEvent(EventType.ARTICLE_NOT_FOUND);
					logger(`article uri('${nextState.params.articleUri}') not found`, e);
				});
		},
		TicketsContainer: (props: any) => {
			const { chatEnabled } = baseWidgetProps.widgetConfig.modulesConfig;
			return (
				<TicketsContainer baseWidgetProps={baseWidgetProps}>
					{React.cloneElement(props.children, { key: props.location.pathname })}
					{!chatEnabled ? kbBtnComp() : null}
				</TicketsContainer>
			);
		},
		ContactPage: () => (
			<ContactPage
				baseConfig={baseWidgetProps}
			/>
		),
		HalpedPage: () => (
			<HelpedPage
				baseConfig={baseWidgetProps}
			/>
		),
		ChatPage: () => {
			return (
				<ChatRoomLoader
					baseConfig={baseWidgetProps}
				/>
			);
		},
		NotFound: (props: any) => <h1>{props.location.pathname} - 404</h1>,
		LoaderComp: () => <Loader color={baseWidgetProps.widgetConfig.appearance.brandColor} />,
	};
};
